<template>
  <div class="explain">
    <!-- 标题 -->
    <div class="title">
      <span>
        详细图文教程：
      </span>
    </div>
    <!-- 内容1 -->
    <div class="content">
      <span>
        1.如果打开下载的「应用APP」，出现如下图提示，
        <span>记住红线部分的描述文件名</span>
      </span>
    </div>
    <!-- 图1 -->
    <div class="img">
      <img :src="require('@/assets/download_explain_1.png')" alt="" />
    </div>
    <!-- 内容2 -->
    <div class="content">
      <span>
        2.然后在设备中点击
        <span>
          【设置>>通用>>描述文件】(iOS9上叫“描述文件”, iOS10上叫“设备管理)
        </span>
        ，找到刚才同名的描述文件
      </span>
    </div>
    <!-- 图2 -->
    <div class="img">
      <img :src="require('@/assets/download_explain_2.png')" alt="" />
    </div>
    <!-- 图3 -->
    <div class="img">
      <img :src="require('@/assets/download_explain_3.png')" alt="" />
    </div>
    <!-- 内容3 -->
    <div class="content">
      <span>
        3.点击文件，
        <span>
          选择【信任】
        </span>
        ，然后就能正常打开APP了
      </span>
    </div>
    <!-- 图4 -->
    <div class="img">
      <img :src="require('@/assets/download_explain_4.png')" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExplainApp',
};
</script>
